import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-fhe-users',
  templateUrl: './fhe-users.component.html',
  styleUrls: ['./fhe-users.component.css']
})
export class FheUsersComponent implements OnInit, OnDestroy {
  users: any[] = [];
  dtOptions: DataTables.Settings = {};

  // We use this trigger because fetching the list of users can take a while,
  // thus we ensure the data is fetched before rendering
  dtTrigger: Subject<any> = new Subject<any>();

  constructor(private userService: UserService) { }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 50
    };

    this.userService.getFheUsers().toPromise().then((res: any) => {
      this.users = res.users;

      // Calling the DT trigger to manually render the table
      this.dtTrigger.next();
    });
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }
}
